<template>
    <v-container>
        <v-dialog width="944" v-model="dialog">
            <v-card>
                <v-card-title>
                    <div class="py-4">Список объектов договора № {{ contract_number }}</div>
                </v-card-title>
                <v-card-text>
                    <v-skeleton-loader height="200" type="table" v-if="isLoading || !objects" />
                    <v-data-table
                        v-else
                        class="px-4"
                        id="objectContractActsTable"
                        :headers="headers"
                        :items="objects"
                        :server-items-length="rowCount"
                        disable-filtering
                        disable-sort
                        disable-pagination
                        :footer-props="{ 'items-per-page-options': [itemsPerPage] }"
                    >
                        <template v-slot:item.address_full_name="{ item }">
                            <div>
                                <div class="black--text">
                                    {{ item['address_full_name'] }}
                                </div>
                                <div class="black--text text--secondary">
                                    {{ item['district_name'] }}
                                </div>
                            </div>
                        </template>
                        <template v-slot:item.act="{ item }">
                            <div>
                                <v-btn @click="chooseItem(item)" color="gray" class="white--text" rounded>выбрать</v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions class="d-flex justify-end pa-4">
                    <div class="px-4">
                        <v-btn rounded color="gray" outlined @click="closeObjectDialog">закрыть</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import translate from '@/utils/translate.util';

export default {
    name: 'ObjectsContractActsTable',
    props: ['value', 'contractId', 'contract_number'],
    data: function() {
        return {
            headers: [
                {
                    text: 'Код объекта',
                    value: 'obj_contract_number',
                    width: 148
                },
                {
                    text: 'Объект',
                    value: 'object_name',
                    width: 272
                },
                {
                    text: 'Адрес',
                    value: 'address_full_name',
                    width: 280
                },
                {
                    text: 'Действие',
                    value: 'act'
                }
            ]
        };
    },
    computed: {
        ...mapGetters('contracts', ['getObjectContracts']),
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        objects() {
            return translate(this.getObjectContracts.objects, 'full', this.$i18n.locale);
        },
        isLoading() {
            return this.getObjectContracts.isLoading;
        },
        rowCount() {
            return this.getObjectContracts.pagination.rowCount;
        },
        itemsPerPage() {
            return this.getObjectContracts.pagination.itemsPerPage;
        }
    },
    methods: {
        ...mapActions('contracts', ['getUserObjectContractsList']),
        chooseItem(item) {
            this.$emit('chooseObject', item['obj_suppl_rid']);
        },
        closeObjectDialog() {
            this.dialog = false;
        }
    },
    watch: {
        value(val) {
            if (val) {
                this.getUserObjectContractsList(this.contractId);
            }
        }
    }
};
</script>

<style lang="scss">
#objectContractActsTable tbody {
    tr:hover {
        background-color: transparent !important;
    }
}
</style>
